import { Listbox, Transition } from '@headlessui/react'
import { createFilterOptions } from '@mui/material/Autocomplete'
import Image from 'next/image'
import { useRouter } from 'next/router'
import React, { memo, useEffect, useState } from 'react'
import useUploadStore from '../../store/uploadStore'
import AutoSuggestionSearch from './AutoSuggestionSearch'
const filter = createFilterOptions<optionType>()

interface optionType {
  name: string
  inputValue?: string
  id: string
}

const SearchBox = () => {
  const { categoryList } = useUploadStore()
  const router = useRouter()
  const [currentRoute, setCurrentRoute] = useState<string | null>(null)
  const [category, setCategory] = useState('All Categories')
  const [value, setValue] = React.useState<string>('')

  const getCategoryObject = (categoryKey: string) => {
    return categoryList.find((cat) => cat.key === categoryKey)
  }

  useEffect(() => {}, [category, categoryList])

  useEffect(() => {
    if (!router.isReady || !categoryList) return
    const path = router.asPath.slice(1)
    if (path.match(/categories\/[a-zA-Z0-9]+\/search\/.+/)) {
      setCurrentRoute('search')
      const currentQuery = decodeURIComponent(path.split('/')[3].split('?')[0])
      setValue(currentQuery)
    }
    const currentCategory = path.split('/')[1]
    const currentCategoryObj = getCategoryObject(currentCategory)
    if (currentCategoryObj) setCategory(currentCategoryObj)
    else setCategory(categoryList[0])
  }, [router, categoryList])

  const [dictionary, setDictionary] = useState<Array<any>>([])

  const getCategoryKey = (categoryName: string) => {
    return categoryList.find((cat) => cat.name === categoryName)?.key
  }

  // console.log(category, currentCategory)

  return (
    <div className="flex w-full col-span-2 flex-row items-center self-center font-oswaldregular md:w-auto">
      <Listbox
        value={category}
        onChange={(category) => {
          if (currentRoute === 'search')
            router.push(`/categories/${category.key}/search/${value}`)
          else setCategory(category)
        }}
        // className="relative bg-gray-800 w-48"
      >
        {({ open }) => (
          <div className="relative">
            <Listbox.Button className="md:min-w-auto w-max min-w-[115px] bg-white/20 px-3 py-2 text-left text-gray-400 md:w-36">
              <div className="flex flex-row items-center justify-between">
                <span className="brightness-200">
                  {category?.name ?? 'All Categories'}
                </span>
                <Image
                  src="/down.png"
                  className="h-6 w-6"
                  width={24}
                  height={24}
                />
              </div>
            </Listbox.Button>
            <Transition
              show={open}
              className="absolute top-14 w-full"
              enter="transition duration-100 ease-out"
              enterFrom="transform scale-95 opacity-0"
              enterTo="transform scale-100 opacity-100"
              leave="transition duration-75 ease-out"
              leaveFrom="transform scale-100 opacity-100"
              leaveTo="transform scale-95 opacity-0"
            >
              <Listbox.Options className="w-full text-white shadow-2xl">
                {[...categoryList].map((category) => (
                  <Listbox.Option
                    key={category?.name}
                    value={category}
                    className="w-full cursor-pointer border-b-2 border-gray-700 bg-gray-900 p-4 hover:brightness-150"
                  >
                    {category?.name.charAt(0).toUpperCase() +
                      category?.name?.slice(1, category?.name.length)}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        )}
      </Listbox>
      <AutoSuggestionSearch
        currentValue={value}
        setCurrentValue={setValue}
        category={category?.key}
      />
      {/* <Autocomplete
        value={value}
        onChange={(event, newValue) => {
          if (typeof newValue === 'string') {
            setValue({
              name: newValue,
            });
          } else if (newValue && newValue.inputValue) {
            // Create a new value from the user input
            setValue({
              name: newValue.inputValue,
            });
          } else {
            setValue(newValue);
          }
        }}
        filterOptions={(options, params) => { 
          // console.log("============");
          // console.log("options",options,params)
          const filtered = filter(options, params);
          // console.log('filtered',filtered)

          const { inputValue } = params;
          
          const sorted = options.filter(options => options.name.indexOf(inputValue) > -1);
          // setDictionary(sorted)

          const isExisting = options.some((option) => option.name.indexOf(inputValue) !== -1);
          // // console.log(isExisting)
          
          if (inputValue !== '' && !isExisting) {
            filtered.push({
              inputValue,
              id: (Math.random() * 10).toString(),
              name: `Search "${inputValue}"`,
            });
            // console.log('final ',filtered)
          }
          
          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        // id="free-solo-with-text-demo"
        options={dictionary}
        getOptionLabel={(option) => {
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.name;
        }}
        // renderOption={(props, option) => <li {...props}>{option.name}</li>}
        sx={{ width: 300 }}
        freeSolo
        renderInput={(params) => (
          <TextField {...params} variant="standard" 
          sx={{"& .MuiInputBase-input.MuiAutocomplete-input": {
            color: "white",
            opacity: "40%",
            pl: 1
          },}}/>
        )}
  
      /> */}
      {/* <input
        type="text"
        onChange={(e) => {

        }}
        placeholder="Type here to search for an item"
        className="p-2 bg-gray-900 outline-none text-white placeholder:text-gray-700 w-3/5"
      /> */}
      {/* <button disabled={value.length <= 2 || !category} className="bg-white px-3 py-2" onClick={() => search(value,getCategoryKey(category.key))}>
        <Image src="/icons/search.svg" width={16} height={16} />
      </button> */}
      {/* <div
        onClick={() => {
          if (value.length > 2 && category?.name) {
            router.push(`/categories/${category.key}/search/${value}`)
          }
        }}
      >
        <div className="bg-white px-4 py-3">
          <Image src="/icons/search.svg" alt="search" width={16} height={16} />
        </div>
      </div> */}
    </div>
  )
}

export default memo(SearchBox)
